import React, { useEffect, useState } from "react";
import Navbar from "../../components/ComponentesHome/Navbar";
import Header from "../../components/ComponentesHome/Header";
import ContactForm from "../../components/ComponentesHome/ContactForm";
import FloatingButton from "../../components/ComponentesHome/FloatingButton";
import SponsorsSection from "../../components/ComponentesHome/SponsorsSection";
import Nosotros from "../../components/ComponentesHome/Nosotros";
import Clientes from "../../components/ComponentesHome/Clientes";
import Servicios from "../../components/ComponentesHome/Servicios";
import Footer from "../../components/ComponentesHome/Footer";
import Loader from "../../components/ComponentesHome/Loader";
import AlquilerSection from "../../components/ComponentesHome/AlquilerSection";
import CategoriaProductos from "../../components/ComponentesHome/CategoriaProductos";
import "./Home.css";
import { obtenerRegistrosActivos } from "../../api/headers.service";

export function Home() {
  const [loading, setLoading] = useState(true);
  const [selectOptionAlquiler, setSelectOptionAlquiler] = useState(null);
  const [sectionAlquilerView, setSectionAlquilerView] = useState(false);
  const [headers, setHeaders] = useState([]);
  const [categories, setCategories] = useState([]);
  const [enterprise, setEnterprise] = useState(null);
  const [servicios, setServicios] = useState([]);
  const [clientes, setClientes] = useState([]);

  const getHeaders = async () => {
    setLoading(true);
    try {
      const result = await obtenerRegistrosActivos();

      if (result.headers.length > 0) {
        setHeaders(result.headers);
        setCategories(result.categories);
        setEnterprise(result.empresa);
        setServicios(result.servicios);
        setClientes(result?.clientes);
      } else {
        const headers = [
          {
            image:
              "https://cdn.pixabay.com/photo/2018/02/26/22/17/machine-3184176_1280.jpg",
            title: "Máquinas de Alta Calidad",
            description:
              "Herramientas que llevan tus proyectos al siguiente nivel.",
          },
        ];
        setHeaders(headers);
      }
    } catch (error) {
      const headers = [
        {
          image:
            "https://grupoprima-files.s3.amazonaws.com/uploads/ex01init-3ad4ad0f-300a-4b8f-b316-062684cf8ba4.webp",
          title: "Máquinas de Alta Calidad",
          description:
            "Herramientas que llevan tus proyectos al siguiente nivel.",
        },
      ];
      setHeaders(headers);
      console.log("error al obtener headers");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getHeaders();
  }, []);

  if (loading) return <Loader />;
  return (
    <>
      <Navbar
        setSectionAlquilerView={setSectionAlquilerView}
        setSelectOptionAlquiler={setSelectOptionAlquiler}
        categories={categories}
        enterprise={enterprise}
      />

      {sectionAlquilerView === false ? (
        <>
          <Header slides={headers} />
          <SponsorsSection />
          <Nosotros />
          <AlquilerSection
            categories={categories}
            enterprise={enterprise}
            setSectionAlquilerView={setSectionAlquilerView}
            setSelectOptionAlquiler={setSelectOptionAlquiler}
          />
          <Clientes clientes={clientes} />
          <Servicios servicios={servicios} />
          <ContactForm enterprise={enterprise} categories={categories} />
        </>
      ) : (
        <CategoriaProductos
          selectOptionAlquiler={selectOptionAlquiler}
          enterprise={enterprise}
        />
      )}

      <Footer enterprise={enterprise} />
      <FloatingButton enterprise={enterprise} />
    </>
  );
}
